import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { fetchContentEntry } from 'b2b-apps/shop/content/redux/contentEntries/actionCreators';
import { getEntryById } from 'b2b-apps/shop/content/redux/contentEntries/selectors';
import { ContentEntryType } from 'b2b-apps/shop/content/redux/contentEntries/types';

type UseEntryReturnType = RemoteRecord<ContentEntryType>;

const useEntry = (entryId: string): UseEntryReturnType => {
  const dispatch = useDispatch();
  const content = useSelector(
    useCallback((state: State) => getEntryById(state, entryId), [entryId]),
  );

  useEffect(
    (): void => {
      if (!content.isLoaded) {
        dispatch(fetchContentEntry(entryId));
      }
    },
    [content.isLoaded, dispatch, entryId],
  );

  return content;
};

export {
  useEntry,
};
export type {
  UseEntryReturnType,
};
